module.exports = __webpack_public_path__ + "img/portfolio-shpilkina.cd939c5a.png";